import React from 'react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';

import { setActiveReduxModal } from '../../ducks/feedActions';
import { feedTracker } from '../../../../shared/utils/amplitudeHelper';

const Container = styled('button')`
  width: 420px;
  min-height: 200px;
  height: 200px;
  margin: 0 auto 30px auto;
  background-color: #f0f0f0;
  color: #ffffff;
  border-radius: 10px;
  border: 1px dashed #979797;
  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: #ffffff;
  }
  @media screen and (max-width: 1200px) {
    height: 250px;
    width: 250px;
  }
`;

const PlusIconWrapper = styled('div')`
  height: 80px;
  width: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 70px;
  margin: 0px auto;
  line-height: 80px;
  background-color: #0DCC8A;
`;

const AddPrWidgetButton = () => {
  const dispatch = useDispatch();
  const showAddPrModal = () => {
    dispatch(setActiveReduxModal('add-top-performance-modal'));
    feedTracker('TV Mode', 'Add top performance modal opened');
  };

  return (
    <Container onClick={showAddPrModal}>
      <PlusIconWrapper>
        <span>+</span>
      </PlusIconWrapper>
    </Container>
  );
};

export default AddPrWidgetButton;
